// Local development auth bypass.
//
// When VITE_DEV_AUTH=true the app skips Cognito/OIDC entirely and identifies the
// user with an email sent to the backend via the `X-Dev-Email` header. The
// backend's matching dev bypass (AUTH_DEV_BYPASS, non-prod) provisions the user.
// NEVER enable this against a production backend.
//
// The identity can be overridden at runtime via localStorage (key
// `saasd.devEmail`), which lets e2e tests run each case as an isolated tenant.

export const DEV_AUTH = import.meta.env.VITE_DEV_AUTH === 'true';

const ENV_EMAIL = import.meta.env.VITE_DEV_EMAIL ?? 'dev@local.test';
const STORAGE_KEY = 'saasd.devEmail';

export function getDevEmail(): string {
  if (typeof localStorage !== 'undefined') {
    const override = localStorage.getItem(STORAGE_KEY);
    if (override) return override;
  }
  return ENV_EMAIL;
}

// A stable subject derived from the email so re-logins map to the same user.
export function getDevSub(): string {
  return getDevEmail();
}
